var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisualizationSelectionStackedBar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#81848F",
  d: "M2 46h46v2H0V0h2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#81848F",
  d: "M21 4v10H6V4zm10 14v10H6V18zm-5 14v10H6V32z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C1C7",
  d: "M28 4v10h-6V4zm16 14v10H32V18zm-7 14v10H27V32z"
}))));
export default SvgVisualizationSelectionStackedBar;